import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { Timezone, TypeGuard } from '@principle-theorem/shared';
import { flow, isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';

export const PATIENT_ALLERGY_RESOURCE_TYPE = 'patientAllergy';

export const PATIENT_ALLERGY_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Patient Allergy List',
    description: '',
    idPrefix: PATIENT_ALLERGY_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ID4WPatientAllergy {
  patient_id: number;
  allergy_id: number;
  description: string;
}

export interface ID4WPatientAllergyFilters {
  patient_id: string;
}

export function isD4WPatientAllergy(
  item: unknown,
  logError: boolean
): item is ID4WPatientAllergy {
  return TypeGuard.interface<ID4WPatientAllergy>(
    {
      patient_id: isNumber,
      allergy_id: isNumber,
      description: isString,
    },
    logError
  )(item);
}

const PATIENT_ALLERGY_QUERY = `
SELECT
  patient_id,
  allergy_id,
  allergy.description AS description
FROM pat_allergy
LEFT JOIN allergy ON allergy.id = pat_allergy.allergy_id
WHERE patient_id IS NOT NULL`;

export type D4WPatientAllergy = ISourceEntityTypes<
  ID4WPatientAllergy,
  object,
  ID4WPatientAllergyFilters
>;

export class PatientAllergySourceEntity extends BaseSourceEntity<D4WPatientAllergy> {
  sourceEntity = PATIENT_ALLERGY_SOURCE_ENTITY;
  entityResourceType = PATIENT_ALLERGY_RESOURCE_TYPE;
  sourceQuery = PATIENT_ALLERGY_QUERY;
  verifySourceFn = isD4WPatientAllergy;

  override transformDataFn = flow([]);

  translate(): object {
    return {};
  }

  getSourceRecordId(data: ID4WPatientAllergy): string {
    return `${data.patient_id}-${data.allergy_id}`;
  }

  getSourceLabel(data: ID4WPatientAllergy): string {
    return `${data.patient_id}-${data.allergy_id}`;
  }

  getFilterData(
    data: ID4WPatientAllergy,
    _timezone: Timezone
  ): ID4WPatientAllergyFilters {
    return { patient_id: data.patient_id.toString() };
  }
}
